import { render, staticRenderFns } from "./error-popup.vue?vue&type=template&id=2c0bee88&scoped=true&"
import script from "./error-popup.ts?vue&type=script&lang=ts&"
export * from "./error-popup.ts?vue&type=script&lang=ts&"
import style0 from "./error-popup.scss?vue&type=style&index=0&id=2c0bee88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bee88",
  null
  
)

export default component.exports